export async function calculateFileSha256(file: File): Promise<string> {
  if (!(file instanceof File)) {
    throw new Error('Invalid input: not a File object')
  }
  const arrayBuffer = await file.arrayBuffer()
  const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}
